/* eslint-disable */
import React, { useState, useEffect, useContext, createRef } from "react";

import { Link } from "react-router-dom";

// kendo react modules ==========================
import "@progress/kendo-theme-material/dist/all.css";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";

// impoting excel colums
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";

//api url requirement
import * as url from "urlhelpers/UrlHelper";
import { getData } from "utils/Gateway";

//import context
import { GlobalProvider } from "context/GlobalContext";

//import translation function for language translation
import { useTranslation } from "react-i18next";

const ConceptList = ({
  downloadExcel,
  search,
  setRecords,
  checkedRecordCount,
}) => {
  const token = localStorage.getItem("token"); // token
  const { t } = useTranslation(); //for translation

  const {
    reloadConceptList,
    setReloadConceptList,
    setEditConceptData,
    screenHeight,
  } = useContext(GlobalProvider);

  const [conceptList, setConceptList] = useState([]);
  const [responseReceived, setResponseReceived] = useState(false);

  // without pagination ------------------------------------
  const initialDataState = {};
  const [dataState, setDataState] = useState();
  const [result, setResult] = useState(process(conceptList, initialDataState));

  const onDataStateChange = (event) => {
    setDataState(event.dataState);
    setResult(process(conceptList, event.dataState));
  };
  /* Handle the button's onClick event and set it to export the data by using the ExcelExport save method. */
  const _exporter = createRef();

  const exportExcel = () => {
    if (_exporter.current) {
      _exporter.current.save();
    }
  };

  /* function to search */
  const filterData = () => {
    if (!result || !result.data) {
      return []; // Return an empty array if result or result.data is undefined
    }

    const filteredData = result.data.filter((item) => {
      const name = item?.title?.toLowerCase() || "";
      const conceptdate = item?.conceptdate || "";

      return (
        (name && name.includes(search.toLowerCase())) ||
        (conceptdate && conceptdate.includes(search))
      );
    });
    setRecords(filteredData.length);
    return filteredData;
  };

  /* function to get all label data */
  const getAllConceptList = async () => {
    try {
      let requestUrl =
        url.API_BASEURL + url.API_GET_ALL_CONCEPT + `?token=${token}`;

      console.log("concept list url =====>>>", requestUrl);

      const response = await getData(requestUrl);

      console.log("concept list response ========>>>", response);

      if (response.data) {
        setConceptList(response.data);
        setResponseReceived(true);
        dataState
          ? setResult(process(response.data, dataState))
          : setResult(process(response.data, initialDataState));
        setRecords(response.data.length);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  // check the selected count and show the count in top and also selected download xls ------------------------
  const handelSelectedCount = () => {
    let checkboxes = document.querySelectorAll(
      'input[name="selectConceptRecord"]'
    );

    let totalSelected = 0;
    let filteredData = [];
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        totalSelected++;
        const filteredUser = conceptList.find(
          (user) => user._id === checkbox.value
        );
        filteredUser && filteredData.push(filteredUser);
      }
    });

    // Update the content of the block
    checkedRecordCount(totalSelected);
    return filteredData;
  };

  // mark all checkbox as selected ----------------
  const selectAllRecords = (e) => {
    document
      .querySelectorAll('.k-master-row input[name="selectConceptRecord"]')
      .forEach((checkbox) => {
        checkbox.checked = e.target.checked;
      });
    handelSelectedCount();
  };

  // blocks to replace the Grid HTML ==============================================
  const SelectRecordHeader = () => {
    return (
      <div className="d-flex align-items-center">
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id="selectAllMain"
            onClick={selectAllRecords}
          />
        </div>
      </div>
    );
  };

  /* Select single row */
  const SelectRecordRow = (props) => {
    return (
      <td>
        <div className="form-check">
          <input
            className="form-check-input "
            type="checkbox"
            value={props.dataItem._id}
            name="selectConceptRecord"
            onClick={handelSelectedCount}
          />
        </div>
      </td>
    );
  };

  /* custom title html */
  const titleHtml = ({ dataItem }) => {
    return (
      <td className="title">
        <div className="d-flex align-items-center gap-2">
          <span>{dataItem.name}</span>
          <Link
            to="#addUpdateConceptPopup"
            data-bs-toggle="offcanvas"
            className="ml-auto edit_icon"
          >
            <span
              className="d-block material-symbols-outlined icon-md"
              onClick={() => {
                setEditConceptData(dataItem);
              }}
            >
              edit
            </span>
          </Link>
        </div>
      </td>
    );
  };

  /* hook to reload list */
  useEffect(() => {
    if (reloadConceptList || !responseReceived) {
      getAllConceptList();
      setResult(process(conceptList, initialDataState));
      if (reloadConceptList) {
        setReloadConceptList(false);
      }
    }
  }, [reloadConceptList, responseReceived]);

  /* hook to hit  exportExcel() function*/
  useEffect(() => {
    downloadExcel && exportExcel();
  }, [downloadExcel]);

  /* hook to hit filterData function on search */
  useEffect(() => {
    filterData();
  }, [search]);

  /* set records based on onDataStateChange */
  useEffect(() => {
    setRecords(result.data.length);
  }, [result]);

  return (
    <div className="table-responsive">
      {/* ============ download xls start ========== */}
      <ExcelExport
        data={
          handelSelectedCount().length > 0 ? handelSelectedCount() : conceptList
        }
        fileName="Concept.xlsx"
        ref={_exporter}
      >
        <ExcelExportColumn field="name" title={t("Name")} />
        <ExcelExportColumn field="conceptdate" title={t("Date")} />
      </ExcelExport>

      {/* ============ download xls end ========== */}
      {search ? (
        <Grid
          style={{ height: screenHeight }}
          data={filterData()}
          filterable={true}
          sortable={true}
          groupable={true}
          onDataStateChange={onDataStateChange}
          {...dataState}
          //pageable = {true}
          //total = {products.length}
          reorderable
          // resizable
        >
          <GridColumn
            field="id"
            headerCell={SelectRecordHeader}
            cell={SelectRecordRow}
            filterable={false}
            sortable={false}
            width="70px"
          />
          <GridColumn
            cell={titleHtml}
            field="name"
            title={t("Title")}
            //width="200px"
          />
          <GridColumn field="conceptdate" title={t("Date")} 
          //width="200px" 
          />
        </Grid>
      ) : (
        <Grid
          style={{ height: screenHeight }}
          data={result}
          filterable={true}
          sortable={true}
          groupable={true}
          onDataStateChange={onDataStateChange}
          {...dataState}
          //pageable = {true}
          //total = {products.length}
          reorderable
          // resizable
        >
          <GridColumn
            field="id"
            headerCell={SelectRecordHeader}
            cell={SelectRecordRow}
            filterable={false}
            sortable={false}
            width="70px"
          />
          <GridColumn
            cell={titleHtml}
            field="name"
            title={t("Title")}
            //width="200px"
          />
          <GridColumn field="conceptdate" title={t("Date")} 
          //width="200px" 
          />
        </Grid>
      )}
    </div>
  );
};

export default ConceptList;
